import React from 'react';

import Actions from '@app/action';
import Store from '@app/store';

import I18n from '@module/i18n';
import Analytics from '@module/analytics';

import Button from '@component/form/element/button';
import Checkbox from '@component/form/element/checkbox';
import TextField from '@component/form/element/textfield';

export default class SignInForm extends React.Component {
  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      remember_me: true,
    };

    this.detectAutoFill = this.detectAutoFill.bind(this);
    this.signinAttempt = this.signinAttempt.bind(this);
  }

  componentDidMount() {
    this.detectAutoFill();
  }

  componentWillUnmount() {
    Store.dispatch(Actions.Notification.resetNotification());
  }

  resetFormErrors() {
    Store.dispatch(Actions.Errors.resetFormErrors('signin'));
  }

  detectAutoFill() {
    const email = this.emailNode.value || '';
    const password = this.passwordNode.value || '';
    this.setState({ email: email.trim(), password });
  }

  signinAttempt(e) {
    e.preventDefault();
    Store.dispatch(
      Actions.User.signin(
        this.state.email,
        this.state.password,
        this.state.remember_me
      )
    );

    Analytics.trackStructEvent({
      category: 'plus',
      action: 'click_signin',
      label: 'half_panel',
    });

    document.activeElement.blur();
  }

  render() {
    const { pending, errors } = Store.getState();
    const valid = errors.signin ? -1 : 0;
    const buttonActive =
      !errors.signin &&
      this.state.email &&
      this.state.password &&
      !pending.signin;
    const forgotPasswordLink = (
      <a
        key="forgot_password_link"
        href="/forgot-password"
        tabIndex="-1"
        className="forgot-password-link"
      >
        {' '}
        {I18n.t('form.signin.link.forgot_password')}{' '}
      </a>
    );

    return (
      <div className="signin-form">
        <div className="signin-form--form-container">
          <h2>{I18n.t('form.signin.title')}</h2>
          <form
            method="post"
            ref={(node) => (this.signinFormNode = node)}
            onSubmit={this.signinAttempt}
            onKeyDown={this.resetFormErrors}
          >
            <TextField
              value={this.state.email}
              valid={valid}
              fieldRef={(node) => (this.emailNode = node)}
              onChange={(e) => this.setState({ email: e.target.value })}
              onBlur={this.detectAutoFill}
              onFocus={this.detectAutoFill}
              tabIndex={1}
              type="email"
              name="email"
              label={I18n.t('form.signin.label.email')}
            />
            <TextField
              value={this.state.password}
              valid={valid}
              fieldRef={(node) => (this.passwordNode = node)}
              onChange={(e) => this.setState({ password: e.target.value })}
              onBlur={this.detectAutoFill}
              onFocus={this.detectAutoFill}
              tabIndex={2}
              type="password"
              name="password"
              label={I18n.t('form.signin.label.password')}
            />
            <Button
              active={!!buttonActive}
              text={I18n.t('form.signin.button.submit')}
              tabIndex={4}
              submit={true}
            />
            <Checkbox
              checked={this.state.remember_me}
              className="signin-form__options"
              label={I18n.t('form.signin.label.remember_me')}
              name="remember_me"
              onChange={(e) => this.setState({ remember_me: e.target.checked })}
              tabIndex={3}
            />
            {forgotPasswordLink}
          </form>
        </div>
      </div>
    );
  }
}
